import React from 'react';

export const Indent: React.FC<{ depth: number }> = ({ depth, children }) => (
  <div style={{ marginLeft: 16 * depth, position: 'relative' }}>{children}</div>
);
